export default __webpack_public_path__ + "static/media/logo.3b7d1f40.png";